import React from 'react';
import WorkBoxContext from './WorkBoxContext';

var UpdateAvailable = function UpdateAvailable(_ref) {
  var children = _ref.children;
  return React.createElement(WorkBoxContext.Consumer, null, function (_ref2) {
    var isUpdateAvailable = _ref2.isUpdateAvailable;

    if (typeof children === 'function') {
      return children(isUpdateAvailable);
    }

    return isUpdateAvailable && children;
  });
};

export default UpdateAvailable;